// extracted by mini-css-extract-plugin
export default {"container_with_image":"svg-wrapper_container_with_image__8cTd5","svg":"svg-wrapper_svg__67rQW"};